module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/description-pict-169b3b4d795bbaff020511d341021bfe.jpg";